import React, { useEffect, useRef } from 'react';

function RenderLinks() {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const wrapperEl = wrapperRef.current;

    if (!wrapperEl) {
      console.warn("Wrapper element not found on mount.");
      return;
    }

    // Use requestAnimationFrame to delay script injection until after paint
    const frameId = requestAnimationFrame(() => {
      const script = document.createElement('script');
      script.src = 'static/js/main.js';
      script.async = true;
      wrapperEl.appendChild(script);

      // Cleanup function
      return () => {
        if (wrapperEl.contains(script)) {
          wrapperEl.removeChild(script);
        }
      };
    });

    // Cleanup if component unmounts before animation frame
    return () => cancelAnimationFrame(frameId);
  }, []);

  return <div ref={wrapperRef} className="wrapper"></div>;
}

export default RenderLinks;
